import { ExecutionContext } from "../types/ExecutionContext";

/**
 * This entity represents an analytics tracker. Ex. Google or Bing tracker.
 */
export abstract class AnalyticsTracker<T> {
	private _executionContext!: ExecutionContext;

	/**
	 * The execution context to use to submit events.
	 *
	 * @returns the execution context.
	 */
	get executionContext(): ExecutionContext {
		return this._executionContext;
	}

	/**
	 * The execution context to use to submit events.
	 */
	set executionContext(context: ExecutionContext) {
		this._executionContext = context;
	}

	/**
	 * Initializes an analytics tracker.
	 */
	abstract submitPageView(): void;
	/**
	 * Sends an event to analytics.
	 *
	 * @param eventData The event data to use for sending an event.
	 */
	abstract submitEvent(eventData: T): void;
}
